import React, { useState, useEffect } from "react";
import {
  addData,
  updateData,
  getStudentIdData,
  getStudentIdDataWithLesson,
} from "../../../lib/studenttranscript";
import { useAuth } from "../../../usercontext";
import SubGrade from "./subgrade";

import PageNotes from "../../pages/common/pagenotes";

export default function GlobalTranskript({slug}) {
  //Orjinali goalquestion/test.jsx
  //English
  const [englishId, setEnglishId] = useState();
  const [english6lesson1, setEnglish6Lesson1] = useState("");
  const [english6lesson2, setEnglish6Lesson2] = useState("");
  const [english6grade1, setEnglish6Grade1] = useState(0);
  const [english6grade2, setEnglish6Grade2] = useState(0);

  const [english7lesson1, setEnglish7Lesson1] = useState("");
  const [english7lesson2, setEnglish7Lesson2] = useState("");
  const [english7grade1, setEnglish7Grade1] = useState(0);
  const [english7grade2, setEnglish7Grade2] = useState(0);

  const [english8lesson1, setEnglish8Lesson1] = useState("");
  const [english8lesson2, setEnglish8Lesson2] = useState("");
  const [english8grade1, setEnglish8Grade1] = useState(0);
  const [english8grade2, setEnglish8Grade2] = useState(0);

  const [english9lesson1, setEnglish9Lesson1] = useState("");
  const [english9lesson2, setEnglish9Lesson2] = useState("");
  const [english9grade1, setEnglish9Grade1] = useState(0);
  const [english9grade2, setEnglish9Grade2] = useState(0);

  const [english10lesson1, setEnglish10Lesson1] = useState("");
  const [english10lesson2, setEnglish10Lesson2] = useState("");
  const [english10grade1, setEnglish10Grade1] = useState(0);
  const [english10grade2, setEnglish10Grade2] = useState(0);

  const [english11lesson1, setEnglish11Lesson1] = useState("");
  const [english11lesson2, setEnglish11Lesson2] = useState("");
  const [english11grade1, setEnglish11Grade1] = useState(0);
  const [english11grade2, setEnglish11Grade2] = useState(0);

  const [english12lesson1, setEnglish12Lesson1] = useState("");
  const [english12lesson2, setEnglish12Lesson2] = useState("");
  const [english12grade1, setEnglish12Grade1] = useState(0);
  const [english12grade2, setEnglish12Grade2] = useState(0);
  //Math
  const [mathId, setMathId] = useState();
  const [math6lesson1, setMath6Lesson1] = useState("");
  const [math6lesson2, setMath6Lesson2] = useState("");
  const [math6grade1, setMath6Grade1] = useState(0);
  const [math6grade2, setMath6Grade2] = useState(0);

  const [math7lesson1, setMath7Lesson1] = useState("");
  const [math7lesson2, setMath7Lesson2] = useState("");
  const [math7grade1, setMath7Grade1] = useState(0);
  const [math7grade2, setMath7Grade2] = useState(0);

  const [math8lesson1, setMath8Lesson1] = useState("");
  const [math8lesson2, setMath8Lesson2] = useState("");
  const [math8grade1, setMath8Grade1] = useState(0);
  const [math8grade2, setMath8Grade2] = useState(0);

  const [math9lesson1, setMath9Lesson1] = useState("");
  const [math9lesson2, setMath9Lesson2] = useState("");
  const [math9grade1, setMath9Grade1] = useState(0);
  const [math9grade2, setMath9Grade2] = useState(0);

  const [math10lesson1, setMath10Lesson1] = useState("");
  const [math10lesson2, setMath10Lesson2] = useState("");
  const [math10grade1, setMath10Grade1] = useState(0);
  const [math10grade2, setMath10Grade2] = useState(0);

  const [math11lesson1, setMath11Lesson1] = useState("");
  const [math11lesson2, setMath11Lesson2] = useState("");
  const [math11grade1, setMath11Grade1] = useState(0);
  const [math11grade2, setMath11Grade2] = useState(0);

  const [math12lesson1, setMath12Lesson1] = useState("");
  const [math12lesson2, setMath12Lesson2] = useState("");
  const [math12grade1, setMath12Grade1] = useState(0);
  const [math12grade2, setMath12Grade2] = useState(0);

  //Science
  const [scienceId, setScienceId] = useState();
  const [science6lesson1, setScience6Lesson1] = useState("");
  const [science6lesson2, setScience6Lesson2] = useState("");
  const [science6grade1, setScience6Grade1] = useState(0);
  const [science6grade2, setScience6Grade2] = useState(0);

  const [science7lesson1, setScience7Lesson1] = useState("");
  const [science7lesson2, setScience7Lesson2] = useState("");
  const [science7grade1, setScience7Grade1] = useState(0);
  const [science7grade2, setScience7Grade2] = useState(0);

  const [science8lesson1, setScience8Lesson1] = useState("");
  const [science8lesson2, setScience8Lesson2] = useState("");
  const [science8grade1, setScience8Grade1] = useState(0);
  const [science8grade2, setScience8Grade2] = useState(0);

  const [science9lesson1, setScience9Lesson1] = useState("");
  const [science9lesson2, setScience9Lesson2] = useState("");
  const [science9grade1, setScience9Grade1] = useState(0);
  const [science9grade2, setScience9Grade2] = useState(0);

  const [science10lesson1, setScience10Lesson1] = useState("");
  const [science10lesson2, setScience10Lesson2] = useState("");
  const [science10grade1, setScience10Grade1] = useState(0);
  const [science10grade2, setScience10Grade2] = useState(0);

  const [science11lesson1, setScience11Lesson1] = useState("");
  const [science11lesson2, setScience11Lesson2] = useState("");
  const [science11grade1, setScience11Grade1] = useState(0);
  const [science11grade2, setScience11Grade2] = useState(0);

  const [science12lesson1, setScience12Lesson1] = useState("");
  const [science12lesson2, setScience12Lesson2] = useState("");
  const [science12grade1, setScience12Grade1] = useState(0);
  const [science12grade2, setScience12Grade2] = useState(0);
  //Social Studies
  const [socialId, setSocialId] = useState();
  const [social6lesson1, setSocial6Lesson1] = useState("");
  const [social6lesson2, setSocial6Lesson2] = useState("");
  const [social6grade1, setSocial6Grade1] = useState(0);
  const [social6grade2, setSocial6Grade2] = useState(0);

  const [social7lesson1, setSocial7Lesson1] = useState("");
  const [social7lesson2, setSocial7Lesson2] = useState("");
  const [social7grade1, setSocial7Grade1] = useState(0);
  const [social7grade2, setSocial7Grade2] = useState(0);

  const [social8lesson1, setSocial8Lesson1] = useState("");
  const [social8lesson2, setSocial8Lesson2] = useState("");
  const [social8grade1, setSocial8Grade1] = useState(0);
  const [social8grade2, setSocial8Grade2] = useState(0);

  const [social9lesson1, setSocial9Lesson1] = useState("");
  const [social9lesson2, setSocial9Lesson2] = useState("");
  const [social9grade1, setSocial9Grade1] = useState(0);
  const [social9grade2, setSocial9Grade2] = useState(0);

  const [social10lesson1, setSocial10Lesson1] = useState("");
  const [social10lesson2, setSocial10Lesson2] = useState("");
  const [social10grade1, setSocial10Grade1] = useState(0);
  const [social10grade2, setSocial10Grade2] = useState(0);

  const [social11lesson1, setSocial11Lesson1] = useState("");
  const [social11lesson2, setSocial11Lesson2] = useState("");
  const [social11grade1, setSocial11Grade1] = useState(0);
  const [social11grade2, setSocial11Grade2] = useState(0);

  const [social12lesson1, setSocial12Lesson1] = useState("");
  const [social12lesson2, setSocial12Lesson2] = useState("");
  const [social12grade1, setSocial12Grade1] = useState(0);
  const [social12grade2, setSocial12Grade2] = useState(0);

  //F. Lang
  const [flangId, setFlangId] = useState();
  const [flang6lesson1, setFlang6Lesson1] = useState("");
  const [flang6lesson2, setFlang6Lesson2] = useState("");
  const [flang6grade1, setFlang6Grade1] = useState(0);
  const [flang6grade2, setFlang6Grade2] = useState(0);

  const [flang7lesson1, setFlang7Lesson1] = useState("");
  const [flang7lesson2, setFlang7Lesson2] = useState("");
  const [flang7grade1, setFlang7Grade1] = useState(0);
  const [flang7grade2, setFlang7Grade2] = useState(0);

  const [flang8lesson1, setFlang8Lesson1] = useState("");
  const [flang8lesson2, setFlang8Lesson2] = useState("");
  const [flang8grade1, setFlang8Grade1] = useState(0);
  const [flang8grade2, setFlang8Grade2] = useState(0);

  const [flang9lesson1, setFlang9Lesson1] = useState("");
  const [flang9lesson2, setFlang9Lesson2] = useState("");
  const [flang9grade1, setFlang9Grade1] = useState(0);
  const [flang9grade2, setFlang9Grade2] = useState(0);

  const [flang10lesson1, setFlang10Lesson1] = useState("");
  const [flang10lesson2, setFlang10Lesson2] = useState("");
  const [flang10grade1, setFlang10Grade1] = useState(0);
  const [flang10grade2, setFlang10Grade2] = useState(0);

  const [flang11lesson1, setFlang11Lesson1] = useState("");
  const [flang11lesson2, setFlang11Lesson2] = useState("");
  const [flang11grade1, setFlang11Grade1] = useState(0);
  const [flang11grade2, setFlang11Grade2] = useState(0);

  const [flang12lesson1, setFlang12Lesson1] = useState("");
  const [flang12lesson2, setFlang12Lesson2] = useState("");
  const [flang12grade1, setFlang12Grade1] = useState(0);
  const [flang12grade2, setFlang12Grade2] = useState(0);
  //PE-Art-Music
  const [partmusicId, setPartmusicId] = useState();
  const [partmusic6lesson1, setPartmusic6Lesson1] = useState("");
  const [partmusic6lesson2, setPartmusic6Lesson2] = useState("");
  const [partmusic6grade1, setPartmusic6Grade1] = useState(0);
  const [partmusic6grade2, setPartmusic6Grade2] = useState(0);

  const [partmusic7lesson1, setPartmusic7Lesson1] = useState("");
  const [partmusic7lesson2, setPartmusic7Lesson2] = useState("");
  const [partmusic7grade1, setPartmusic7Grade1] = useState(0);
  const [partmusic7grade2, setPartmusic7Grade2] = useState(0);

  const [partmusic8lesson1, setPartmusic8Lesson1] = useState("");
  const [partmusic8lesson2, setPartmusic8Lesson2] = useState("");
  const [partmusic8grade1, setPartmusic8Grade1] = useState(0);
  const [partmusic8grade2, setPartmusic8Grade2] = useState(0);

  const [partmusic9lesson1, setPartmusic9Lesson1] = useState("");
  const [partmusic9lesson2, setPartmusic9Lesson2] = useState("");
  const [partmusic9grade1, setPartmusic9Grade1] = useState(0);
  const [partmusic9grade2, setPartmusic9Grade2] = useState(0);

  const [partmusic10lesson1, setPartmusic10Lesson1] = useState("");
  const [partmusic10lesson2, setPartmusic10Lesson2] = useState("");
  const [partmusic10grade1, setPartmusic10Grade1] = useState(0);
  const [partmusic10grade2, setPartmusic10Grade2] = useState(0);

  const [partmusic11lesson1, setPartmusic11Lesson1] = useState("");
  const [partmusic11lesson2, setPartmusic11Lesson2] = useState("");
  const [partmusic11grade1, setPartmusic11Grade1] = useState(0);
  const [partmusic11grade2, setPartmusic11Grade2] = useState(0);

  const [partmusic12lesson1, setPartmusic12Lesson1] = useState("");
  const [partmusic12lesson2, setPartmusic12Lesson2] = useState("");
  const [partmusic12grade1, setPartmusic12Grade1] = useState(0);
  const [partmusic12grade2, setPartmusic12Grade2] = useState(0);
  //Electives
  const [electivesId, setElectivesId] = useState();
  const [electives6lesson1, setElectives6Lesson1] = useState("");
  const [electives6lesson2, setElectives6Lesson2] = useState("");
  const [electives6grade1, setElectives6Grade1] = useState(0);
  const [electives6grade2, setElectives6Grade2] = useState(0);

  const [electives7lesson1, setElectives7Lesson1] = useState("");
  const [electives7lesson2, setElectives7Lesson2] = useState("");
  const [electives7grade1, setElectives7Grade1] = useState(0);
  const [electives7grade2, setElectives7Grade2] = useState(0);

  const [electives8lesson1, setElectives8Lesson1] = useState("");
  const [electives8lesson2, setElectives8Lesson2] = useState("");
  const [electives8grade1, setElectives8Grade1] = useState(0);
  const [electives8grade2, setElectives8Grade2] = useState(0);

  const [electives9lesson1, setElectives9Lesson1] = useState("");
  const [electives9lesson2, setElectives9Lesson2] = useState("");
  const [electives9grade1, setElectives9Grade1] = useState(0);
  const [electives9grade2, setElectives9Grade2] = useState(0);

  const [electives10lesson1, setElectives10Lesson1] = useState("");
  const [electives10lesson2, setElectives10Lesson2] = useState("");
  const [electives10grade1, setElectives10Grade1] = useState(0);
  const [electives10grade2, setElectives10Grade2] = useState(0);

  const [electives11lesson1, setElectives11Lesson1] = useState("");
  const [electives11lesson2, setElectives11Lesson2] = useState("");
  const [electives11grade1, setElectives11Grade1] = useState(0);
  const [electives11grade2, setElectives11Grade2] = useState(0);

  const [electives12lesson1, setElectives12Lesson1] = useState("");
  const [electives12lesson2, setElectives12Lesson2] = useState("");
  const [electives12grade1, setElectives12Grade1] = useState(0);
  const [electives12grade2, setElectives12Grade2] = useState(0);

  const [questionlist, setQuestionlist] = useState([]);
  const [studentQuestionList, setStudentQuestionList] = useState([]);
  const { profile } = useAuth();
  const [status, setStatus] = useState("");

  //const slug = "6cd022a6-81d9-4aba-8487-fd34f1ffd4c9";
  const [studentInfo, setStudentInfo] = useState(0);
  const [showmessage, setShowMessage] = useState(false);

  const [tab, setTab] = useState(1);

  //console.log("Task",profile);
  const toggleTab = (id) => {
    setTab(id);
  };
  //const slug = profile.id;

  const handleSubmit = async (e) => {
    e.preventDefault();

    /*
    Daha sonra bak
    const form = e.target;
    const formData = new FormData(form);
    const formJson = Object.fromEntries(formData.entries());
    console.log("formJson",formJson);

    const formel = [...formData.entries()];
    console.log("formel",formel);

    Object.entries(formel).forEach(entry => {
      const [key, value] = entry;
      console.log("keyValue",key, value[0], value[1]);
    });
*/

    if (status == "Add") {
      console.log("Add");

      await addData({
        studentId: slug,
        lessonname: "English",
        class6lesson1: english6lesson1,
        class6grade1: english6grade1,
        class6lesson2: english6lesson2,
        class6grade2: english6grade2,
        class7lesson1: english7lesson1,
        class7grade1: english7grade1,
        class7lesson2: english7lesson2,
        class7grade2: english7grade2,
        class8lesson1: english8lesson1,
        class8grade1: english8grade1,
        class8lesson2: english8lesson2,
        class8grade2: english8grade2,
        class9lesson1: english9lesson1,
        class9grade1: english9grade1,
        class9lesson2: english9lesson2,
        class9grade2: english9grade2,
        class10lesson1: english10lesson1,
        class10grade1: english10grade1,
        class10lesson2: english10lesson2,
        class10grade2: english10grade2,
        class11lesson1: english11lesson1,
        class11grade1: english11grade1,
        class11lesson2: english11lesson2,
        class11grade2: english11grade2,
        class12lesson1: english12lesson1,
        class12grade1: english12grade1,
        class12lesson2: english12lesson2,
        class12grade2: english12grade2,
      });

      await addData({
        studentId: slug,
        lessonname: "Math",
        class6lesson1: math6lesson1,
        class6grade1: math6grade1,
        class6lesson2: math6lesson2,
        class6grade2: math6grade2,
        class7lesson1: math7lesson1,
        class7grade1: math7grade1,
        class7lesson2: math7lesson2,
        class7grade2: math7grade2,
        class8lesson1: math8lesson1,
        class8grade1: math8grade1,
        class8lesson2: math8lesson2,
        class8grade2: math8grade2,
        class9lesson1: math9lesson1,
        class9grade1: math9grade1,
        class9lesson2: math9lesson2,
        class9grade2: math9grade2,
        class10lesson1: math10lesson1,
        class10grade1: math10grade1,
        class10lesson2: math10lesson2,
        class10grade2: math10grade2,
        class11lesson1: math11lesson1,
        class11grade1: math11grade1,
        class11lesson2: math11lesson2,
        class11grade2: math11grade2,
        class12lesson1: math12lesson1,
        class12grade1: math12grade1,
        class12lesson2: math12lesson2,
        class12grade2: math12grade2,
      });

      await addData({
        studentId: slug,
        lessonname: "Science",
        class6lesson1: science6lesson1,
        class6grade1: science6grade1,
        class6lesson2: science6lesson2,
        class6grade2: science6grade2,
        class7lesson1: science7lesson1,
        class7grade1: science7grade1,
        class7lesson2: science7lesson2,
        class7grade2: science7grade2,
        class8lesson1: science8lesson1,
        class8grade1: science8grade1,
        class8lesson2: science8lesson2,
        class8grade2: science8grade2,
        class9lesson1: science9lesson1,
        class9grade1: science9grade1,
        class9lesson2: science9lesson2,
        class9grade2: science9grade2,
        class10lesson1: science10lesson1,
        class10grade1: science10grade1,
        class10lesson2: science10lesson2,
        class10grade2: science10grade2,
        class11lesson1: science11lesson1,
        class11grade1: science11grade1,
        class11lesson2: science11lesson2,
        class11grade2: science11grade2,
        class12lesson1: science12lesson1,
        class12grade1: science12grade1,
        class12lesson2: science12lesson2,
        class12grade2: science12grade2,
      });

      await addData({
        studentId: slug,
        lessonname: "Social",
        class6lesson1: social6lesson1,
        class6grade1: social6grade1,
        class6lesson2: social6lesson2,
        class6grade2: social6grade2,
        class7lesson1: social7lesson1,
        class7grade1: social7grade1,
        class7lesson2: social7lesson2,
        class7grade2: social7grade2,
        class8lesson1: social8lesson1,
        class8grade1: social8grade1,
        class8lesson2: social8lesson2,
        class8grade2: social8grade2,
        class9lesson1: social9lesson1,
        class9grade1: social9grade1,
        class9lesson2: social9lesson2,
        class9grade2: social9grade2,
        class10lesson1: social10lesson1,
        class10grade1: social10grade1,
        class10lesson2: social10lesson2,
        class10grade2: social10grade2,
        class11lesson1: social11lesson1,
        class11grade1: social11grade1,
        class11lesson2: social11lesson2,
        class11grade2: social11grade2,
        class12lesson1: social12lesson1,
        class12grade1: social12grade1,
        class12lesson2: social12lesson2,
        class12grade2: social12grade2,
      });

      await addData({
        studentId: slug,
        lessonname: "Flang",
        class6lesson1: flang6lesson1,
        class6grade1: flang6grade1,
        class6lesson2: flang6lesson2,
        class6grade2: flang6grade2,
        class7lesson1: flang7lesson1,
        class7grade1: flang7grade1,
        class7lesson2: flang7lesson2,
        class7grade2: flang7grade2,
        class8lesson1: flang8lesson1,
        class8grade1: flang8grade1,
        class8lesson2: flang8lesson2,
        class8grade2: flang8grade2,
        class9lesson1: flang9lesson1,
        class9grade1: flang9grade1,
        class9lesson2: flang9lesson2,
        class9grade2: flang9grade2,
        class10lesson1: flang10lesson1,
        class10grade1: flang10grade1,
        class10lesson2: flang10lesson2,
        class10grade2: flang10grade2,
        class11lesson1: flang11lesson1,
        class11grade1: flang11grade1,
        class11lesson2: flang11lesson2,
        class11grade2: flang11grade2,
        class12lesson1: flang12lesson1,
        class12grade1: flang12grade1,
        class12lesson2: flang12lesson2,
        class12grade2: flang12grade2,
      });

      await addData({
        studentId: slug,
        lessonname: "PE-Art-Music",
        class6lesson1: partmusic6lesson1,
        class6grade1: partmusic6grade1,
        class6lesson2: partmusic6lesson2,
        class6grade2: partmusic6grade2,
        class7lesson1: partmusic7lesson1,
        class7grade1: partmusic7grade1,
        class7lesson2: partmusic7lesson2,
        class7grade2: partmusic7grade2,
        class8lesson1: partmusic8lesson1,
        class8grade1: partmusic8grade1,
        class8lesson2: partmusic8lesson2,
        class8grade2: partmusic8grade2,
        class9lesson1: partmusic9lesson1,
        class9grade1: partmusic9grade1,
        class9lesson2: partmusic9lesson2,
        class9grade2: partmusic9grade2,
        class10lesson1: partmusic10lesson1,
        class10grade1: partmusic10grade1,
        class10lesson2: partmusic10lesson2,
        class10grade2: partmusic10grade2,
        class11lesson1: partmusic11lesson1,
        class11grade1: partmusic11grade1,
        class11lesson2: partmusic11lesson2,
        class11grade2: partmusic11grade2,
        class12lesson1: partmusic12lesson1,
        class12grade1: partmusic12grade1,
        class12lesson2: partmusic12lesson2,
        class12grade2: partmusic12grade2,
      });

      await addData({
        studentId: slug,
        lessonname: "Electives",
        class6lesson1: electives6lesson1,
        class6grade1: electives6grade1,
        class6lesson2: electives6lesson2,
        class6grade2: electives6grade2,
        class7lesson1: electives7lesson1,
        class7grade1: electives7grade1,
        class7lesson2: electives7lesson2,
        class7grade2: electives7grade2,
        class8lesson1: electives8lesson1,
        class8grade1: electives8grade1,
        class8lesson2: electives8lesson2,
        class8grade2: electives8grade2,
        class9lesson1: electives9lesson1,
        class9grade1: electives9grade1,
        class9lesson2: electives9lesson2,
        class9grade2: electives9grade2,
        class10lesson1: electives10lesson1,
        class10grade1: electives10grade1,
        class10lesson2: electives10lesson2,
        class10grade2: electives10grade2,
        class11lesson1: electives11lesson1,
        class11grade1: electives11grade1,
        class11lesson2: electives11lesson2,
        class11grade2: electives11grade2,
        class12lesson1: electives12lesson1,
        class12grade1: electives12grade1,
        class12lesson2: electives12lesson2,
        class12grade2: electives12grade2,
      });
    } else {
      console.log("Update");

      await updateData({
        id: englishId,
        lessonname: "English",
        class6lesson1: english6lesson1,
        class6grade1: english6grade1,
        class6lesson2: english6lesson2,
        class6grade2: english6grade2,
        class7lesson1: english7lesson1,
        class7grade1: english7grade1,
        class7lesson2: english7lesson2,
        class7grade2: english7grade2,
        class8lesson1: english8lesson1,
        class8grade1: english8grade1,
        class8lesson2: english8lesson2,
        class8grade2: english8grade2,
        class9lesson1: english9lesson1,
        class9grade1: english9grade1,
        class9lesson2: english9lesson2,
        class9grade2: english9grade2,
        class10lesson1: english10lesson1,
        class10grade1: english10grade1,
        class10lesson2: english10lesson2,
        class10grade2: english10grade2,
        class11lesson1: english11lesson1,
        class11grade1: english11grade1,
        class11lesson2: english11lesson2,
        class11grade2: english11grade2,
        class12lesson1: english12lesson1,
        class12grade1: english12grade1,
        class12lesson2: english12lesson2,
        class12grade2: english12grade2,
      });
      console.log("mathId", mathId);
      await updateData({
        id: mathId,
        lessonname: "Math",
        class6lesson1: math6lesson1,
        class6grade1: math6grade1,
        class6lesson2: math6lesson2,
        class6grade2: math6grade2,
        class7lesson1: math7lesson1,
        class7grade1: math7grade1,
        class7lesson2: math7lesson2,
        class7grade2: math7grade2,
        class8lesson1: math8lesson1,
        class8grade1: math8grade1,
        class8lesson2: math8lesson2,
        class8grade2: math8grade2,
        class9lesson1: math9lesson1,
        class9grade1: math9grade1,
        class9lesson2: math9lesson2,
        class9grade2: math9grade2,
        class10lesson1: math10lesson1,
        class10grade1: math10grade1,
        class10lesson2: math10lesson2,
        class10grade2: math10grade2,
        class11lesson1: math11lesson1,
        class11grade1: math11grade1,
        class11lesson2: math11lesson2,
        class11grade2: math11grade2,
        class12lesson1: math12lesson1,
        class12grade1: math12grade1,
        class12lesson2: math12lesson2,
        class12grade2: math12grade2,
      });

      await updateData({
        id: scienceId,
        lessonname: "Science",
        class6lesson1: science6lesson1,
        class6grade1: science6grade1,
        class6lesson2: science6lesson2,
        class6grade2: science6grade2,
        class7lesson1: science7lesson1,
        class7grade1: science7grade1,
        class7lesson2: science7lesson2,
        class7grade2: science7grade2,
        class8lesson1: science8lesson1,
        class8grade1: science8grade1,
        class8lesson2: science8lesson2,
        class8grade2: science8grade2,
        class9lesson1: science9lesson1,
        class9grade1: science9grade1,
        class9lesson2: science9lesson2,
        class9grade2: science9grade2,
        class10lesson1: science10lesson1,
        class10grade1: science10grade1,
        class10lesson2: science10lesson2,
        class10grade2: science10grade2,
        class11lesson1: science11lesson1,
        class11grade1: science11grade1,
        class11lesson2: science11lesson2,
        class11grade2: science11grade2,
        class12lesson1: science12lesson1,
        class12grade1: science12grade1,
        class12lesson2: science12lesson2,
        class12grade2: science12grade2,
      });

      await updateData({
        id: socialId,
        lessonname: "Social",
        class6lesson1: social6lesson1,
        class6grade1: social6grade1,
        class6lesson2: social6lesson2,
        class6grade2: social6grade2,
        class7lesson1: social7lesson1,
        class7grade1: social7grade1,
        class7lesson2: social7lesson2,
        class7grade2: social7grade2,
        class8lesson1: social8lesson1,
        class8grade1: social8grade1,
        class8lesson2: social8lesson2,
        class8grade2: social8grade2,
        class9lesson1: social9lesson1,
        class9grade1: social9grade1,
        class9lesson2: social9lesson2,
        class9grade2: social9grade2,
        class10lesson1: social10lesson1,
        class10grade1: social10grade1,
        class10lesson2: social10lesson2,
        class10grade2: social10grade2,
        class11lesson1: social11lesson1,
        class11grade1: social11grade1,
        class11lesson2: social11lesson2,
        class11grade2: social11grade2,
        class12lesson1: social12lesson1,
        class12grade1: social12grade1,
        class12lesson2: social12lesson2,
        class12grade2: social12grade2,
      });

      await updateData({
        id: flangId,
        lessonname: "Flang",
        class6lesson1: flang6lesson1,
        class6grade1: flang6grade1,
        class6lesson2: flang6lesson2,
        class6grade2: flang6grade2,
        class7lesson1: flang7lesson1,
        class7grade1: flang7grade1,
        class7lesson2: flang7lesson2,
        class7grade2: flang7grade2,
        class8lesson1: flang8lesson1,
        class8grade1: flang8grade1,
        class8lesson2: flang8lesson2,
        class8grade2: flang8grade2,
        class9lesson1: flang9lesson1,
        class9grade1: flang9grade1,
        class9lesson2: flang9lesson2,
        class9grade2: flang9grade2,
        class10lesson1: flang10lesson1,
        class10grade1: flang10grade1,
        class10lesson2: flang10lesson2,
        class10grade2: flang10grade2,
        class11lesson1: flang11lesson1,
        class11grade1: flang11grade1,
        class11lesson2: flang11lesson2,
        class11grade2: flang11grade2,
        class12lesson1: flang12lesson1,
        class12grade1: flang12grade1,
        class12lesson2: flang12lesson2,
        class12grade2: flang12grade2,
      });

      await updateData({
        id: partmusicId,
        lessonname: "PE-Art-Music",
        class6lesson1: partmusic6lesson1,
        class6grade1: partmusic6grade1,
        class6lesson2: partmusic6lesson2,
        class6grade2: partmusic6grade2,
        class7lesson1: partmusic7lesson1,
        class7grade1: partmusic7grade1,
        class7lesson2: partmusic7lesson2,
        class7grade2: partmusic7grade2,
        class8lesson1: partmusic8lesson1,
        class8grade1: partmusic8grade1,
        class8lesson2: partmusic8lesson2,
        class8grade2: partmusic8grade2,
        class9lesson1: partmusic9lesson1,
        class9grade1: partmusic9grade1,
        class9lesson2: partmusic9lesson2,
        class9grade2: partmusic9grade2,
        class10lesson1: partmusic10lesson1,
        class10grade1: partmusic10grade1,
        class10lesson2: partmusic10lesson2,
        class10grade2: partmusic10grade2,
        class11lesson1: partmusic11lesson1,
        class11grade1: partmusic11grade1,
        class11lesson2: partmusic11lesson2,
        class11grade2: partmusic11grade2,
        class12lesson1: partmusic12lesson1,
        class12grade1: partmusic12grade1,
        class12lesson2: partmusic12lesson2,
        class12grade2: partmusic12grade2,
      });

      await updateData({
        id: electivesId,
        lessonname: "Electives",
        class6lesson1: electives6lesson1,
        class6grade1: electives6grade1,
        class6lesson2: electives6lesson2,
        class6grade2: electives6grade2,
        class7lesson1: electives7lesson1,
        class7grade1: electives7grade1,
        class7lesson2: electives7lesson2,
        class7grade2: electives7grade2,
        class8lesson1: electives8lesson1,
        class8grade1: electives8grade1,
        class8lesson2: electives8lesson2,
        class8grade2: electives8grade2,
        class9lesson1: electives9lesson1,
        class9grade1: electives9grade1,
        class9lesson2: electives9lesson2,
        class9grade2: electives9grade2,
        class10lesson1: electives10lesson1,
        class10grade1: electives10grade1,
        class10lesson2: electives10lesson2,
        class10grade2: electives10grade2,
        class11lesson1: electives11lesson1,
        class11grade1: electives11grade1,
        class11lesson2: electives11lesson2,
        class11grade2: electives11grade2,
        class12lesson1: electives12lesson1,
        class12grade1: electives12grade1,
        class12lesson2: electives12lesson2,
        class12grade2: electives12grade2,
      });
    }
    setShowMessage(true);
    window.scrollTo(0, 0);
    RecordCheck();
  };

  async function GetLessons() {
    const englishdata = await getStudentIdDataWithLesson(slug, "English");
    //console.log("englishdata", englishdata);
    setEnglishId(englishdata[0].id);
    setEnglish6Lesson1(englishdata[0].class6lesson1);
    setEnglish6Grade1(englishdata[0].class6grade1);
    setEnglish6Lesson2(englishdata[0].class6lesson2);
    setEnglish6Grade2(englishdata[0].class6grade2);
    setEnglish7Lesson1(englishdata[0].class7lesson1);
    setEnglish7Grade1(englishdata[0].class7grade1);
    setEnglish7Lesson2(englishdata[0].class7lesson2);
    setEnglish7Grade2(englishdata[0].class7grade2);
    setEnglish8Lesson1(englishdata[0].class8lesson1);
    setEnglish8Grade1(englishdata[0].class8grade1);
    setEnglish8Lesson2(englishdata[0].class8lesson2);
    setEnglish8Grade2(englishdata[0].class8grade2);
    setEnglish9Lesson1(englishdata[0].class9lesson1);
    setEnglish9Grade1(englishdata[0].class9grade1);
    setEnglish9Lesson2(englishdata[0].class9lesson2);
    setEnglish9Grade2(englishdata[0].class9grade2);
    setEnglish10Lesson1(englishdata[0].class10lesson1);
    setEnglish10Grade1(englishdata[0].class10grade1);
    setEnglish10Lesson2(englishdata[0].class10lesson2);
    setEnglish10Grade2(englishdata[0].class10grade2);
    setEnglish11Lesson1(englishdata[0].class11lesson1);
    setEnglish11Grade1(englishdata[0].class11grade1);
    setEnglish11Lesson2(englishdata[0].class11lesson2);
    setEnglish11Grade2(englishdata[0].class11grade2);
    setEnglish12Lesson1(englishdata[0].class12lesson1);
    setEnglish12Grade1(englishdata[0].class12grade1);
    setEnglish12Lesson2(englishdata[0].class12lesson2);
    setEnglish12Grade2(englishdata[0].class12grade2);

    const mathdata = await getStudentIdDataWithLesson(slug, "Math");
    //console.log("mathdata", mathdata);
    setMathId(mathdata[0].id);
    setMath6Lesson1(mathdata[0].class6lesson1);
    setMath6Grade1(mathdata[0].class6grade1);
    setMath6Lesson2(mathdata[0].class6lesson2);
    setMath6Grade2(mathdata[0].class6grade2);
    setMath7Lesson1(mathdata[0].class7lesson1);
    setMath7Grade1(mathdata[0].class7grade1);
    setMath7Lesson2(mathdata[0].class7lesson2);
    setMath7Grade2(mathdata[0].class7grade2);
    setMath8Lesson1(mathdata[0].class8lesson1);
    setMath8Grade1(mathdata[0].class8grade1);
    setMath8Lesson2(mathdata[0].class8lesson2);
    setMath8Grade2(mathdata[0].class8grade2);
    setMath9Lesson1(mathdata[0].class9lesson1);
    setMath9Grade1(mathdata[0].class9grade1);
    setMath9Lesson2(mathdata[0].class9lesson2);
    setMath9Grade2(mathdata[0].class9grade2);
    setMath10Lesson1(mathdata[0].class10lesson1);
    setMath10Grade1(mathdata[0].class10grade1);
    setMath10Lesson2(mathdata[0].class10lesson2);
    setMath10Grade2(mathdata[0].class10grade2);
    setMath11Lesson1(mathdata[0].class11lesson1);
    setMath11Grade1(mathdata[0].class11grade1);
    setMath11Lesson2(mathdata[0].class11lesson2);
    setMath11Grade2(mathdata[0].class11grade2);
    setMath12Lesson1(mathdata[0].class12lesson1);
    setMath12Grade1(mathdata[0].class12grade1);
    setMath12Lesson2(mathdata[0].class12lesson2);
    setMath12Grade2(mathdata[0].class12grade2);

    const sciencedata = await getStudentIdDataWithLesson(slug, "Science");
    //console.log("sciencedata", sciencedata);
    setScienceId(sciencedata[0].id);
    setScience6Lesson1(sciencedata[0].class6lesson1);
    setScience6Grade1(sciencedata[0].class6grade1);
    setScience6Lesson2(sciencedata[0].class6lesson2);
    setScience6Grade2(sciencedata[0].class6grade2);
    setScience7Lesson1(sciencedata[0].class7lesson1);
    setScience7Grade1(sciencedata[0].class7grade1);
    setScience7Lesson2(sciencedata[0].class7lesson2);
    setScience7Grade2(sciencedata[0].class7grade2);
    setScience8Lesson1(sciencedata[0].class8lesson1);
    setScience8Grade1(sciencedata[0].class8grade1);
    setScience8Lesson2(sciencedata[0].class8lesson2);
    setScience8Grade2(sciencedata[0].class8grade2);
    setScience9Lesson1(sciencedata[0].class9lesson1);
    setScience9Grade1(sciencedata[0].class9grade1);
    setScience9Lesson2(sciencedata[0].class9lesson2);
    setScience9Grade2(sciencedata[0].class9grade2);
    setScience10Lesson1(sciencedata[0].class10lesson1);
    setScience10Grade1(sciencedata[0].class10grade1);
    setScience10Lesson2(sciencedata[0].class10lesson2);
    setScience10Grade2(sciencedata[0].class10grade2);
    setScience11Lesson1(sciencedata[0].class11lesson1);
    setScience11Grade1(sciencedata[0].class11grade1);
    setScience11Lesson2(sciencedata[0].class11lesson2);
    setScience11Grade2(sciencedata[0].class11grade2);
    setScience12Lesson1(sciencedata[0].class12lesson1);
    setScience12Grade1(sciencedata[0].class12grade1);
    setScience12Lesson2(sciencedata[0].class12lesson2);
    setScience12Grade2(sciencedata[0].class12grade2);

    const socialdata = await getStudentIdDataWithLesson(slug, "Social");
    //console.log("socialdata", socialdata);
    setSocialId(socialdata[0].id);
    setSocial6Lesson1(socialdata[0].class6lesson1);
    setSocial6Grade1(socialdata[0].class6grade1);
    setSocial6Lesson2(socialdata[0].class6lesson2);
    setSocial6Grade2(socialdata[0].class6grade2);
    setSocial7Lesson1(socialdata[0].class7lesson1);
    setSocial7Grade1(socialdata[0].class7grade1);
    setSocial7Lesson2(socialdata[0].class7lesson2);
    setSocial7Grade2(socialdata[0].class7grade2);
    setSocial8Lesson1(socialdata[0].class8lesson1);
    setSocial8Grade1(socialdata[0].class8grade1);
    setSocial8Lesson2(socialdata[0].class8lesson2);
    setSocial8Grade2(socialdata[0].class8grade2);
    setSocial9Lesson1(socialdata[0].class9lesson1);
    setSocial9Grade1(socialdata[0].class9grade1);
    setSocial9Lesson2(socialdata[0].class9lesson2);
    setSocial9Grade2(socialdata[0].class9grade2);
    setSocial10Lesson1(socialdata[0].class10lesson1);
    setSocial10Grade1(socialdata[0].class10grade1);
    setSocial10Lesson2(socialdata[0].class10lesson2);
    setSocial10Grade2(socialdata[0].class10grade2);
    setSocial11Lesson1(socialdata[0].class11lesson1);
    setSocial11Grade1(socialdata[0].class11grade1);
    setSocial11Lesson2(socialdata[0].class11lesson2);
    setSocial11Grade2(socialdata[0].class11grade2);
    setSocial12Lesson1(socialdata[0].class12lesson1);
    setSocial12Grade1(socialdata[0].class12grade1);
    setSocial12Lesson2(socialdata[0].class12lesson2);
    setSocial12Grade2(socialdata[0].class12grade2);

    const flangdata = await getStudentIdDataWithLesson(slug, "Flang");
    //console.log("flangdata", flangdata);
    setFlangId(flangdata[0].id);
    setFlang6Lesson1(flangdata[0].class6lesson1);
    setFlang6Grade1(flangdata[0].class6grade1);
    setFlang6Lesson2(flangdata[0].class6lesson2);
    setFlang6Grade2(flangdata[0].class6grade2);
    setFlang7Lesson1(flangdata[0].class7lesson1);
    setFlang7Grade1(flangdata[0].class7grade1);
    setFlang7Lesson2(flangdata[0].class7lesson2);
    setFlang7Grade2(flangdata[0].class7grade2);
    setFlang8Lesson1(flangdata[0].class8lesson1);
    setFlang8Grade1(flangdata[0].class8grade1);
    setFlang8Lesson2(flangdata[0].class8lesson2);
    setFlang8Grade2(flangdata[0].class8grade2);
    setFlang9Lesson1(flangdata[0].class9lesson1);
    setFlang9Grade1(flangdata[0].class9grade1);
    setFlang9Lesson2(flangdata[0].class9lesson2);
    setFlang9Grade2(flangdata[0].class9grade2);
    setFlang10Lesson1(flangdata[0].class10lesson1);
    setFlang10Grade1(flangdata[0].class10grade1);
    setFlang10Lesson2(flangdata[0].class10lesson2);
    setFlang10Grade2(flangdata[0].class10grade2);
    setFlang11Lesson1(flangdata[0].class11lesson1);
    setFlang11Grade1(flangdata[0].class11grade1);
    setFlang11Lesson2(flangdata[0].class11lesson2);
    setFlang11Grade2(flangdata[0].class11grade2);
    setFlang12Lesson1(flangdata[0].class12lesson1);
    setFlang12Grade1(flangdata[0].class12grade1);
    setFlang12Lesson2(flangdata[0].class12lesson2);
    setFlang12Grade2(flangdata[0].class12grade2);

    const partmusicdata = await getStudentIdDataWithLesson(
      slug,
      "PE-Art-Music"
    );
    //console.log("partmusicdata", partmusicdata);
    setPartmusicId(partmusicdata[0].id);
    setPartmusic6Lesson1(partmusicdata[0].class6lesson1);
    setPartmusic6Grade1(partmusicdata[0].class6grade1);
    setPartmusic6Lesson2(partmusicdata[0].class6lesson2);
    setPartmusic6Grade2(partmusicdata[0].class6grade2);
    setPartmusic7Lesson1(partmusicdata[0].class7lesson1);
    setPartmusic7Grade1(partmusicdata[0].class7grade1);
    setPartmusic7Lesson2(partmusicdata[0].class7lesson2);
    setPartmusic7Grade2(partmusicdata[0].class7grade2);
    setPartmusic8Lesson1(partmusicdata[0].class8lesson1);
    setPartmusic8Grade1(partmusicdata[0].class8grade1);
    setPartmusic8Lesson2(partmusicdata[0].class8lesson2);
    setPartmusic8Grade2(partmusicdata[0].class8grade2);
    setPartmusic9Lesson1(partmusicdata[0].class9lesson1);
    setPartmusic9Grade1(partmusicdata[0].class9grade1);
    setPartmusic9Lesson2(partmusicdata[0].class9lesson2);
    setPartmusic9Grade2(partmusicdata[0].class9grade2);
    setPartmusic10Lesson1(partmusicdata[0].class10lesson1);
    setPartmusic10Grade1(partmusicdata[0].class10grade1);
    setPartmusic10Lesson2(partmusicdata[0].class10lesson2);
    setPartmusic10Grade2(partmusicdata[0].class10grade2);
    setPartmusic11Lesson1(partmusicdata[0].class11lesson1);
    setPartmusic11Grade1(partmusicdata[0].class11grade1);
    setPartmusic11Lesson2(partmusicdata[0].class11lesson2);
    setPartmusic11Grade2(partmusicdata[0].class11grade2);
    setPartmusic12Lesson1(partmusicdata[0].class12lesson1);
    setPartmusic12Grade1(partmusicdata[0].class12grade1);
    setPartmusic12Lesson2(partmusicdata[0].class12lesson2);
    setPartmusic12Grade2(partmusicdata[0].class12grade2);

    const electivesdata = await getStudentIdDataWithLesson(slug, "Electives");
    //console.log("electivesdata", electivesdata);
    setElectivesId(electivesdata[0].id);
    setElectives6Lesson1(electivesdata[0].class6lesson1);
    setElectives6Grade1(electivesdata[0].class6grade1);
    setElectives6Lesson2(electivesdata[0].class6lesson2);
    setElectives6Grade2(electivesdata[0].class6grade2);
    setElectives7Lesson1(electivesdata[0].class7lesson1);
    setElectives7Grade1(electivesdata[0].class7grade1);
    setElectives7Lesson2(electivesdata[0].class7lesson2);
    setElectives7Grade2(electivesdata[0].class7grade2);
    setElectives8Lesson1(electivesdata[0].class8lesson1);
    setElectives8Grade1(electivesdata[0].class8grade1);
    setElectives8Lesson2(electivesdata[0].class8lesson2);
    setElectives8Grade2(electivesdata[0].class8grade2);
    setElectives9Lesson1(electivesdata[0].class9lesson1);
    setElectives9Grade1(electivesdata[0].class9grade1);
    setElectives9Lesson2(electivesdata[0].class9lesson2);
    setElectives9Grade2(electivesdata[0].class9grade2);
    setElectives10Lesson1(electivesdata[0].class10lesson1);
    setElectives10Grade1(electivesdata[0].class10grade1);
    setElectives10Lesson2(electivesdata[0].class10lesson2);
    setElectives10Grade2(electivesdata[0].class10grade2);
    setElectives11Lesson1(electivesdata[0].class11lesson1);
    setElectives11Grade1(electivesdata[0].class11grade1);
    setElectives11Lesson2(electivesdata[0].class11lesson2);
    setElectives11Grade2(electivesdata[0].class11grade2);
    setElectives12Lesson1(electivesdata[0].class12lesson1);
    setElectives12Grade1(electivesdata[0].class12grade1);
    setElectives12Lesson2(electivesdata[0].class12lesson2);
    setElectives12Grade2(electivesdata[0].class12grade2);
  }

  async function RecordCheck() {
    const sdata = await getStudentIdData(slug);
    console.log("RecordCheck", sdata);

    if (sdata.length === 0) {
      setStatus("Add");
    } else {
      setStatus("Update");
      GetLessons();
    }
  }

  useEffect(() => {
    RecordCheck();
  }, []);

  return (
    <>
      <div className="col-12">
        <div className="col">
          <div className="settings-widget">
            <div className="settings-inner-blk p-2">
              {/* <div className="checkout-form personal-address add-course-info"> */}
                {/* <div className="personal-info-head p-2">
                  <h3>Transcript Planning</h3>
                </div> */}
                {showmessage && (
                  <div
                    className="alert alert-success alert-dismissible fade show"
                    role="alert"
                  >
                    <strong>Updated!</strong> Your Settings.
                    <button
                      type="button"
                      className="btn-close"
                      data-bs-dismiss="alert"
                      aria-label="Close"
                      onClick={(e) => setShowMessage(false)}
                    ></button>
                  </div>
                )}
                <form method="post" onSubmit={handleSubmit}>
                  <div className="container">
                    <div id="tab2">
                      <div className="row fw-bolder m-auto text-center fs-4">
                        <div className="col-2 px-0 text-start">Transcript Planning</div>
                        <div className="col">9</div>
                        <div className="col">10</div>
                        <div className="col">11</div>
                        <div className="col">12</div>
                        {/*}
                      <div className="col">Math</div>
                      <div className="col">Science</div>
                      <div className="col">Social Studies</div>
                      <div className="col">F. Lang</div>
                      <div className="col">PE-Art-Music</div>
                      <div className="col">Electives</div>
                      */}
                      </div>
                      <div className="row fw-bolder mb-4">
                        <div className="col-2 m-auto fs-4">English</div>
                        <SubGrade
                          lessonname={"English9"}
                          lesson1={english9lesson1}
                          setLesson1={setEnglish9Lesson1}
                          lesson2={english9lesson2}
                          setLesson2={setEnglish9Lesson2}
                          grade1={english9grade1}
                          setGrade1={setEnglish9Grade1}
                          grade2={english9grade2}
                          setGrade2={setEnglish9Grade2}
                        />
                        <SubGrade
                          lessonname={"English10"}
                          lesson1={english10lesson1}
                          setLesson1={setEnglish10Lesson1}
                          lesson2={english10lesson2}
                          setLesson2={setEnglish10Lesson2}
                          grade1={english10grade1}
                          setGrade1={setEnglish10Grade1}
                          grade2={english10grade2}
                          setGrade2={setEnglish10Grade2}
                        />

                        <SubGrade
                          lessonname={"English11"}
                          lesson1={english11lesson1}
                          setLesson1={setEnglish11Lesson1}
                          lesson2={english11lesson2}
                          setLesson2={setEnglish11Lesson2}
                          grade1={english11grade1}
                          setGrade1={setEnglish11Grade1}
                          grade2={english11grade2}
                          setGrade2={setEnglish11Grade2}
                        />
                        <SubGrade
                          lessonname={"English12"}
                          lesson1={english12lesson1}
                          setLesson1={setEnglish12Lesson1}
                          lesson2={english12lesson2}
                          setLesson2={setEnglish12Lesson2}
                          grade1={english12grade1}
                          setGrade1={setEnglish12Grade1}
                          grade2={english12grade2}
                          setGrade2={setEnglish12Grade2}
                        />
                      </div>
                      <div className="row fw-bolder  mb-4">
                        <div className="col-2 m-auto fs-4">Math</div>
                        <SubGrade
                          lessonname={"Math9"}
                          lesson1={math9lesson1}
                          setLesson1={setMath9Lesson1}
                          lesson2={math9lesson2}
                          setLesson2={setMath9Lesson2}
                          grade1={math9grade1}
                          setGrade1={setMath9Grade1}
                          grade2={math9grade2}
                          setGrade2={setMath9Grade2}
                        />
                        <SubGrade
                          lessonname={"Math10"}
                          lesson1={math10lesson1}
                          setLesson1={setMath10Lesson1}
                          lesson2={math10lesson2}
                          setLesson2={setMath10Lesson2}
                          grade1={math10grade1}
                          setGrade1={setMath10Grade1}
                          grade2={math10grade2}
                          setGrade2={setMath10Grade2}
                        />

                        <SubGrade
                          lessonname={"Math11"}
                          lesson1={math11lesson1}
                          setLesson1={setMath11Lesson1}
                          lesson2={math11lesson2}
                          setLesson2={setMath11Lesson2}
                          grade1={math11grade1}
                          setGrade1={setMath11Grade1}
                          grade2={math11grade2}
                          setGrade2={setMath11Grade2}
                        />
                        <SubGrade
                          lessonname={"Math12"}
                          lesson1={math12lesson1}
                          setLesson1={setMath12Lesson1}
                          lesson2={math12lesson2}
                          setLesson2={setMath12Lesson2}
                          grade1={math12grade1}
                          setGrade1={setMath12Grade1}
                          grade2={math12grade2}
                          setGrade2={setMath12Grade2}
                        />
                      </div>
                      <div className="row fw-bolder  mb-4">
                        <div className="col-2 m-auto fs-4">Science</div>
                        <SubGrade
                          lessonname={"Science9"}
                          lesson1={science9lesson1}
                          setLesson1={setScience9Lesson1}
                          lesson2={science9lesson2}
                          setLesson2={setScience9Lesson2}
                          grade1={science9grade1}
                          setGrade1={setScience9Grade1}
                          grade2={science9grade2}
                          setGrade2={setScience9Grade2}
                        />
                        <SubGrade
                          lessonname={"Science10"}
                          lesson1={science10lesson1}
                          setLesson1={setScience10Lesson1}
                          lesson2={science10lesson2}
                          setLesson2={setScience10Lesson2}
                          grade1={science10grade1}
                          setGrade1={setScience10Grade1}
                          grade2={science10grade2}
                          setGrade2={setScience10Grade2}
                        />

                        <SubGrade
                          lessonname={"Science11"}
                          lesson1={science11lesson1}
                          setLesson1={setScience11Lesson1}
                          lesson2={science11lesson2}
                          setLesson2={setScience11Lesson2}
                          grade1={science11grade1}
                          setGrade1={setScience11Grade1}
                          grade2={science11grade2}
                          setGrade2={setScience11Grade2}
                        />
                        <SubGrade
                          lessonname={"Science12"}
                          lesson1={science12lesson1}
                          setLesson1={setScience12Lesson1}
                          lesson2={science12lesson2}
                          setLesson2={setScience12Lesson2}
                          grade1={science12grade1}
                          setGrade1={setScience12Grade1}
                          grade2={science12grade2}
                          setGrade2={setScience12Grade2}
                        />
                      </div>
                      <div className="row fw-bolder  mb-4">
                        <div className="col-2 m-auto fs-4">Social Studies</div>
                        <SubGrade
                          lessonname={"Social9"}
                          lesson1={social9lesson1}
                          setLesson1={setSocial9Lesson1}
                          lesson2={social9lesson2}
                          setLesson2={setSocial9Lesson2}
                          grade1={social9grade1}
                          setGrade1={setSocial9Grade1}
                          grade2={social9grade2}
                          setGrade2={setSocial9Grade2}
                        />
                        <SubGrade
                          lessonname={"Social10"}
                          lesson1={social10lesson1}
                          setLesson1={setSocial10Lesson1}
                          lesson2={social10lesson2}
                          setLesson2={setSocial10Lesson2}
                          grade1={social10grade1}
                          setGrade1={setSocial10Grade1}
                          grade2={social10grade2}
                          setGrade2={setSocial10Grade2}
                        />

                        <SubGrade
                          lessonname={"Social11"}
                          lesson1={social11lesson1}
                          setLesson1={setSocial11Lesson1}
                          lesson2={social11lesson2}
                          setLesson2={setSocial11Lesson2}
                          grade1={social11grade1}
                          setGrade1={setSocial11Grade1}
                          grade2={social11grade2}
                          setGrade2={setSocial11Grade2}
                        />
                        <SubGrade
                          lessonname={"Social12"}
                          lesson1={social12lesson1}
                          setLesson1={setSocial12Lesson1}
                          lesson2={social12lesson2}
                          setLesson2={setSocial12Lesson2}
                          grade1={social12grade1}
                          setGrade1={setSocial12Grade1}
                          grade2={social12grade2}
                          setGrade2={setSocial12Grade2}
                        />
                      </div>

                      <div className="row fw-bolder  mb-4">
                        <div className="col-2 m-auto fs-4">F. Lang</div>
                        <SubGrade
                          lessonname={"Flang9"}
                          lesson1={flang9lesson1}
                          setLesson1={setFlang9Lesson1}
                          lesson2={flang9lesson2}
                          setLesson2={setFlang9Lesson2}
                          grade1={flang9grade1}
                          setGrade1={setFlang9Grade1}
                          grade2={flang9grade2}
                          setGrade2={setFlang9Grade2}
                        />
                        <SubGrade
                          lessonname={"Flang10"}
                          lesson1={flang10lesson1}
                          setLesson1={setFlang10Lesson1}
                          lesson2={flang10lesson2}
                          setLesson2={setFlang10Lesson2}
                          grade1={flang10grade1}
                          setGrade1={setFlang10Grade1}
                          grade2={flang10grade2}
                          setGrade2={setFlang10Grade2}
                        />

                        <SubGrade
                          lessonname={"Flang11"}
                          lesson1={flang11lesson1}
                          setLesson1={setFlang11Lesson1}
                          lesson2={flang11lesson2}
                          setLesson2={setFlang11Lesson2}
                          grade1={flang11grade1}
                          setGrade1={setFlang11Grade1}
                          grade2={flang11grade2}
                          setGrade2={setFlang11Grade2}
                        />
                        <SubGrade
                          lessonname={"Flang12"}
                          lesson1={flang12lesson1}
                          setLesson1={setFlang12Lesson1}
                          lesson2={flang12lesson2}
                          setLesson2={setFlang12Lesson2}
                          grade1={flang12grade1}
                          setGrade1={setFlang12Grade1}
                          grade2={flang12grade2}
                          setGrade2={setFlang12Grade2}
                        />
                      </div>

                      <div className="row fw-bolder  mb-4">
                        <div className="col-2 m-auto fs-4">PE-Art-Music</div>
                        <SubGrade
                          lessonname={"Partmusic9"}
                          lesson1={partmusic9lesson1}
                          setLesson1={setPartmusic9Lesson1}
                          lesson2={partmusic9lesson2}
                          setLesson2={setPartmusic9Lesson2}
                          grade1={partmusic9grade1}
                          setGrade1={setPartmusic9Grade1}
                          grade2={partmusic9grade2}
                          setGrade2={setPartmusic9Grade2}
                        />
                        <SubGrade
                          lessonname={"Partmusic10"}
                          lesson1={partmusic10lesson1}
                          setLesson1={setPartmusic10Lesson1}
                          lesson2={partmusic10lesson2}
                          setLesson2={setPartmusic10Lesson2}
                          grade1={partmusic10grade1}
                          setGrade1={setPartmusic10Grade1}
                          grade2={partmusic10grade2}
                          setGrade2={setPartmusic10Grade2}
                        />

                        <SubGrade
                          lessonname={"Partmusic11"}
                          lesson1={partmusic11lesson1}
                          setLesson1={setPartmusic11Lesson1}
                          lesson2={partmusic11lesson2}
                          setLesson2={setPartmusic11Lesson2}
                          grade1={partmusic11grade1}
                          setGrade1={setPartmusic11Grade1}
                          grade2={partmusic11grade2}
                          setGrade2={setPartmusic11Grade2}
                        />

                        <SubGrade
                          lessonname={"Partmusic12"}
                          lesson1={partmusic12lesson1}
                          setLesson1={setPartmusic12Lesson1}
                          lesson2={partmusic12lesson2}
                          setLesson2={setPartmusic12Lesson2}
                          grade1={partmusic12grade1}
                          setGrade1={setPartmusic12Grade1}
                          grade2={partmusic12grade2}
                          setGrade2={setPartmusic12Grade2}
                        />
                      </div>
                      <div className="row fw-bolder  mb-4">
                        <div className="col-2 m-auto fs-4">Electives</div>
                        <SubGrade
                          lessonname={"Electives9"}
                          lesson1={electives9lesson1}
                          setLesson1={setElectives9Lesson1}
                          lesson2={electives9lesson2}
                          setLesson2={setElectives9Lesson2}
                          grade1={electives9grade1}
                          setGrade1={setElectives9Grade1}
                          grade2={electives9grade2}
                          setGrade2={setElectives9Grade2}
                        />
                        <SubGrade
                          lessonname={"Electives10"}
                          lesson1={electives10lesson1}
                          setLesson1={setElectives10Lesson1}
                          lesson2={electives10lesson2}
                          setLesson2={setElectives10Lesson2}
                          grade1={electives10grade1}
                          setGrade1={setElectives10Grade1}
                          grade2={electives10grade2}
                          setGrade2={setElectives10Grade2}
                        />

                        <SubGrade
                          lessonname={"Electives11"}
                          lesson1={electives11lesson1}
                          setLesson1={setElectives11Lesson1}
                          lesson2={electives11lesson2}
                          setLesson2={setElectives11Lesson2}
                          grade1={electives11grade1}
                          setGrade1={setElectives11Grade1}
                          grade2={electives11grade2}
                          setGrade2={setElectives11Grade2}
                        />
                        <SubGrade
                          lessonname={"Electives12"}
                          lesson1={electives12lesson1}
                          setLesson1={setElectives12Lesson1}
                          lesson2={electives12lesson2}
                          setLesson2={setElectives12Lesson2}
                          grade1={electives12grade1}
                          setGrade1={setElectives12Grade1}
                          grade2={electives12grade2}
                          setGrade2={setElectives12Grade2}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="update-profile">
                    <button type="submit" className="btn btn-primary">
                      Update Grade
                    </button>
                  </div>
                </form>
              </div>
            </div>
          {/* </div> */}
        </div>
      </div>
    </>
  );
}
